import { Col, Layout, Row, Spin } from "antd";
import PostGrid from "@components/grid/PostGrid";
import { AttrProps } from "@customTypes/index";

interface IssueArtworkCollectionsProps {
    className?: string;
    attrs: AttrProps;
}

const IssueArtworkCollections = ({ className, attrs }: IssueArtworkCollectionsProps) => {
    const isLoading = false;

    return (
        <Layout className={`covr-issue-artwork mar-bot-15 ${className}`}>
            {attrs?.title
                && <Row className="data-header">
                    <Col>
                        <h2>{attrs.title}</h2>
                    </Col>
                </Row>}
            <Spin size="large" spinning={isLoading}>
                <PostGrid
                    data={attrs?.items}
                    showFields={attrs.showFields}
                    cta={{
                        type: 'IssueCoverArt',
                        imgRatio: `auto`
                    }}
                    perRow={attrs.perRow}
                />
            </Spin>
        </Layout>
    );
};

export default IssueArtworkCollections;

